// @flow

import qs from "qs";
import axios from "axios";

import type {
  ChangePasswordRequest,
  ForgotPasswordRequest,
  ForgotPasswordByUserNameRequest,
  ActivateAccountRequest
} from "../clientModels/UserRequest";
import type {
  ChangePasswordResponse,
  ForgotPasswordResponse,
  ForgotPasswordByUsernameResponse,
  ActivationAccountResponse
} from "../clientModels/UserResponse";
import * as UserMapper from "../mappers/UserMapper";
import * as MapResponse from "../utils/MapResponse";
import { parseString } from "xml2js/lib/parser";

export default class UserProvider {
  request = (uri: string, request: any, responseResolver: any) => {
    const time = new Date().getTime();
    const endPoint = `${uri}?t=${time}`;
    return new Promise((resolve, reject) => {
      const options = {
        method: "POST",
        url: endPoint,
        headers: { "Content-Type": "multipart/form-data" },
        data: qs.stringify(request)
      };

      axios(options)
        .then(response => {
          let responseData = {};

          parseString(response.data, { explicitArray: false, ignoreAttrs: true }, (err, result) => {
            responseData = result;
          });

          if (response.status === 200) {
            if (parseInt(responseData.response.errorCode, 10) === 0) {
              let res = MapResponse.success(responseData.response);
              resolve(responseResolver(res));
            } else {
              console.log("server response encounter error with status: " + JSON.stringify(responseData));
              reject(MapResponse.error(responseData.response));
            }
          } else {
            console.log("server response encounter error with status: " + response.status);
            throw MapResponse.exception(response.status, response.statusText);
          }
        })
        .catch(error => {
          // TODO add here logic for error handling/showing requests exeption on UI(visual representation)
          reject(error);
          throw MapResponse.exception(error.name, error.message);
        });
    });
  };
  changePassword = (apiClientUrl, request: ChangePasswordRequest): Promise<ChangePasswordResponse> =>
    this.request(
      apiClientUrl + "Services/ExternalApi.svc/clientChangeAccountPassword",
      {
        ...UserMapper.mapChangePasswordRequest(request)
      },
      UserMapper.resolveChangePasswordResponse
    );

  forgotPassword = (apiClientUrl, request: ForgotPasswordRequest): Promise<ForgotPasswordResponse> =>
    this.request(
      apiClientUrl + "Services/ExternalApi.svc/clientForgottenPassword",
      {
        ...UserMapper.mapForgotPasswordRequest(request)
      },
      UserMapper.resolveForgotPasswordResponse
    );

  forgotPasswordByUserName = (
    apiClientUrl,
    request: ForgotPasswordByUserNameRequest
  ): Promise<ForgotPasswordByUsernameResponse> =>
    this.request(
      apiClientUrl + "Services/ExternalApi.svc/clientForgottenPassword",
      {
        ...UserMapper.mapForgotPasswordByUserNameRequest(request)
      },
      UserMapper.resolveForgotPasswordByUserNameResponse
    );

  activateAccount = (apiClientUrl, request: ActivateAccountRequest): Promise<ActivationAccountResponse> =>
    this.request(
      apiClientUrl + "Services/ExternalApi.svc/clientActivateAccount",
      {
        ...UserMapper.mapActivationAccountRequest(request)
      },
      UserMapper.resolveActivationAccountResponse
    );
}
